import { ContainerModule, interfaces } from 'inversify';
import { AlertBarBl, IAlertBarBl } from './AlertBar.bl';
import { AlertBarStore, IAlertBarStore } from './AlertBar.store';

export const alertBarModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IAlertBarStore.$).to(AlertBarStore).inSingletonScope();
  bind(IAlertBarBl.$).to(AlertBarBl).inSingletonScope();
});
